import { render, staticRenderFns } from "./SalaMaior.vue?vue&type=template&id=59878c43&scoped=true"
import script from "./SalaMaior.vue?vue&type=script&lang=js"
export * from "./SalaMaior.vue?vue&type=script&lang=js"
import style0 from "./SalaMaior.vue?vue&type=style&index=0&id=59878c43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59878c43",
  null
  
)

export default component.exports